import { render, staticRenderFns } from "./Characters.vue?vue&type=template&id=1d656468&scoped=true&"
import script from "./Characters.vue?vue&type=script&lang=js&"
export * from "./Characters.vue?vue&type=script&lang=js&"
import style0 from "./Characters.vue?vue&type=style&index=0&id=1d656468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d656468",
  null
  
)

export default component.exports